import { render, staticRenderFns } from "./NotificationShowDialog.vue?vue&type=template&id=6319dc78&scoped=true&"
import script from "./NotificationShowDialog.vue?vue&type=script&lang=js&"
export * from "./NotificationShowDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6319dc78",
  null
  
)

export default component.exports